import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
  class: "clock_body"
};
const _hoisted_2 = {
  class: "clock_body_nr"
};
const _hoisted_3 = {
  class: "clock"
};
const _hoisted_4 = {
  class: "clock_top"
};
const _hoisted_5 = {
  class: "clock_details"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "task"
};
const _hoisted_8 = {
  class: "clock_task"
};
const _hoisted_9 = {
  class: "clock_task_nr"
};
const _hoisted_10 = {
  class: "clock_task_nr_text"
};
const _hoisted_11 = {
  style: {
    "flex": "1"
  }
};
const _hoisted_12 = {
  class: "push_btn"
};
const _hoisted_13 = ["src"];
const _hoisted_14 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_van_uploader = _resolveComponent("van-uploader");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[8] || (_cache[8] = _createElementVNode("h1", null, "打卡", -1)), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("h2", null, "已连续签到" + _toDisplayString($setup.contactData.day) + "天", 1), _createElementVNode("div", null, [_createElementVNode("span", null, _toDisplayString($setup.contactData.is_clock ? '今日已签到' : '今日未签到'), 1), _cache[1] || (_cache[1] = _createElementVNode("div", null, " 签到 ", -1))])]), _createElementVNode("div", _hoisted_5, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(7, (item, index) => {
    return _createElementVNode("div", {
      key: index,
      class: _normalizeClass($setup.contactData.day > index ? 'yqd' : $setup.contactData.day == index ? 'dt' : 'wqd')
    }, [_cache[2] || (_cache[2] = _createElementVNode("span", {
      style: {
        "font-weight": "bold"
      }
    }, "+1", -1)), _createElementVNode("img", {
      style: {
        "width": "50px"
      },
      src: 'https://www.mimodental.com/assets/imgData/img/member_clock/' + (index == $setup.contactData.day ? 'dt' : 'qt') + '.png'
    }, null, 8, _hoisted_6), _createElementVNode("span", null, _toDisplayString(index == $setup.contactData.day ? '今日' : '第' + (index + 1) + '日'), 1)], 2);
  }), 64))])]), _createElementVNode("div", _hoisted_7, [_cache[7] || (_cache[7] = _createStaticVNode("<h2 style=\"margin-bottom:20px;\" data-v-69b422a8>今日任务</h2><div class=\"vido_task\" data-v-69b422a8><div class=\"vido_task_top\" data-v-69b422a8><span data-v-69b422a8>观看视频打卡</span><img style=\"width:20px;margin-left:10px;\" src=\"https://www.mimodental.com/assets/imgData/img/member_clock/dt.png\" alt=\"\" data-v-69b422a8><span style=\"color:#FF8E12;\" data-v-69b422a8>+2</span></div><img style=\"flex:1;\" src=\"https://www.mimodental.com/assets/imgData/img/member_clock/vido.png\" alt=\"\" data-v-69b422a8></div>", 2)), _createElementVNode("div", _hoisted_8, [_cache[6] || (_cache[6] = _createStaticVNode("<div class=\"clock_task_top\" data-v-69b422a8><div style=\"display:flex;\" data-v-69b422a8><span data-v-69b422a8>每日拍照打卡</span><img style=\"width:20px;margin-left:10px;\" src=\"https://www.mimodental.com/assets/imgData/img/member_clock/dt.png\" alt=\"\" data-v-69b422a8><span style=\"color:#FF8E12;\" data-v-69b422a8>+2</span></div><div class=\"clock_task_top_btn\" data-v-69b422a8> 提交 </div></div>", 1)), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_cache[3] || (_cache[3] = _createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/img/member_clock/bz.png",
    alt: ""
  }, null, -1)), _createElementVNode("div", _hoisted_11, [_createVNode(_component_el_input, {
    modelValue: $setup.push_data.textarea,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.push_data.textarea = $event),
    rows: 5,
    type: "textarea",
    placeholder: "备注"
  }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_12, [!$setup.push_data.img ? (_openBlock(), _createBlock(_component_van_uploader, {
    key: 0,
    "after-read": $setup.afterReadImg,
    accept: "image/*"
  }, {
    default: _withCtx(() => _cache[4] || (_cache[4] = [_createElementVNode("img", {
      src: "https://www.mimodental.com/assets/imgData/img/member_clock/push_img.png",
      alt: ""
    }, null, -1)])),
    _: 1,
    __: [4]
  }, 8, ["after-read"])) : (_openBlock(), _createElementBlock("img", {
    key: 1,
    src: $setup.push_data.img,
    style: {
      "width": "217px",
      "height": "217px",
      "margin-right": "20px"
    },
    alt: ""
  }, null, 8, _hoisted_13)), !$setup.push_data.vido ? (_openBlock(), _createBlock(_component_van_uploader, {
    key: 2,
    "after-read": $setup.afterReadVido,
    accept: "video/*"
  }, {
    default: _withCtx(() => _cache[5] || (_cache[5] = [_createElementVNode("img", {
      src: "https://www.mimodental.com/assets/imgData/img/member_clock/push_vido.png",
      alt: ""
    }, null, -1)])),
    _: 1,
    __: [5]
  }, 8, ["after-read"])) : (_openBlock(), _createElementBlock("img", {
    key: 3,
    src: $setup.push_data.vido,
    style: {
      "width": "217px",
      "height": "217px"
    },
    alt: ""
  }, null, 8, _hoisted_14))])])])])])]);
}